import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import swal from 'sweetalert2';  
import { Router } from '@angular/router';

@Component({
  selector: 'app-cliente',
  templateUrl: './cliente.component.html',
  styleUrls: ['./cliente.component.scss']
})
export class ClienteComponent implements OnInit {
  id_cliente;
  constructor(
    public authService: AuthService,public router:Router) { }
    bndmenu;
  ngOnInit() {
    this.id_cliente=localStorage.getItem("cliente");
    try {
      this.facturas=localStorage.getItem("facturas");  
    } catch (error) {
      this.facturas=0;
    }

/*    if(Number(localStorage.getItem("cliente"))==1){
      this.bndmenu=false;
    }else{
      this.bndmenu=true;
    }
    this.ls_cliente_preventa();
    
   
    this.secc_(2)*/
    this.loading=true;
    this.preventas=[];
    let postData={ 
      id:this.id_cliente
    };
    var sc="";
    console.log(postData);    
    sc="/api/get_cliente_by_id"
    
    this.authService.service(sc,postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          if (res.length!=0)
          {
            this.preventas=data;
          }          
          
          console.log(res);
          this.bndNvoREsp=true;
          this.bndbtn_ed=true;
          this.secc_(1);
          this.get_responsable(res[0].id);
          this.bdn_edit=1;
          this.txt_fot=res[0].img;
          this.preventa.id=res[0].id;
          this.preventa.nombre=res[0].nombre;
          this.preventa.paterno=res[0].paterno;
          this.preventa.materno=res[0].materno;
          this.preventa.rs=res[0].razonsocial;
          this.preventa.rfc=res[0].rfc;
          this.preventa.cargo=res[0].cargo,
          this.preventa.correo=res[0].correo;
          this.preventa.tel1=res[0].telefono;
          this.preventa.tel2=res[0].telefono2;
          this.preventa.sufijo=res[0].sufijo;
          this.preventa.ext1=res[0].ext1;
          this.preventa.ext2=res[0].ext2;
          this.preventa.pais=res[0].pais;
          this.preventa.estado=res[0].estado;
          this.preventa.municipio=res[0].municipio;
          this.preventa.colonia=res[0].colonia;
          this.preventa.calle=res[0].calle;
          this.preventa.cp=res[0].cp;
          this.preventa.medio=res[0].medio;
          this.preventa.estatus=res[0].estatus;
          this.loading=false; 
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta! ', '', 'error');
        });   


  }
  public URL:any;
  fileToUpload: File = null;
onSelectFile(event,idx) {
  //console.log(event);
  this.URL = event.target.files;
  this.fileToUpload = event.target.files[0];
}
img=""
uploadFileToActivity(){
  console.log("upload");
   
    if (this.fileToUpload) {
      var reader = new FileReader();
      console.log("ok ");
      reader.readAsDataURL(this.fileToUpload); // read file as data url
      const file = this.fileToUpload;
      
      reader.onload = (event) => { 
        this.URL = reader.result;
  
        var tmpDate = new Date();     //  Wed Oct 16 2013 12:37:29 GMT+0200
        var now = tmpDate.getTime();
        let data: any = {
          name: now + '.' + this.ext_(file.type),
          firma: this.URL,
          idx: 1,
          id:this.preventa.id
        }
        
        
        this.foto=data.name;
        data.TYPE = 'pdf';
        data.FILENAME = 'files/' + now + '.pdf',
        
         //this.loading =true;
        //console.log(data);
          
          this.authService.upImagencli(data).then(res => {
            var mm = JSON.stringify(res)
            var dd = JSON.parse(mm)
            this.msg_foto="<span class=green>✔</span> ";
            //console.log("guardado");
            //this.img1.id = res[0].cveevtanx;
            //this.img1.url = this.urlwebimg +  now + ".png";
            this.txt_fot=  now + ".png" 
            //this.loading =false;
              //this.PDF =  dd.detailed_message            
            //swal.fire('DOCUMENTO SE GUARDO EXITOSAMENTE','DOCUMENTO SE GUARDO EXITOSAMENTE','success')
              // console.log(dd.detailed_message)              
  
          },error => {
            swal.fire('¡iImagen demasiado grande! ', '', 'warning');
            this.msg_foto=" <span style=color:red;>X error</span> ";
          }
          )
        }
      }
  }
  ext_(f:any) {
    //console.log(f);
    var c:string[]=f.split("/");
   return c[(c.length-1)]; 
 }
  foto="";
  txt_fot="";
  msg_foto=""
  bndmnugral=true;
    oculta_menu(){
      console.log("-");
      if(this.bndmnugral==true){
        this.bndmnugral=false;
      }else{
        this.bndmnugral=true;
      }
      console.log(this.bndmnugral);
    }
  public loading;
  preventas;
  facturas;
  id_usuario;
  hidCvePersona=0;
  valida_cliente(){
    return true
  }
  tipo_reg="L"
  fn_upd_cliente(){
    if(this.valida_cliente()==true){
      let postData={
        nombre:this.preventa.nombre,
        paterno:this.preventa.paterno,
        materno:this.preventa.materno,
        razonsocial:this.preventa.rs,
        rfc:this.preventa.rfc,
        correo:this.preventa.correo,
        cargo:this.preventa.cargo,
        telefono:this.preventa.tel1,
        telefono2:this.preventa.tel2,
        ext1:this.preventa.ext1,
        ext2:this.preventa.ext2,
        sufijo:this.preventa.sufijo,
        pais:this.preventa.pais,
        estado:this.preventa.estado,
        municipio:this.preventa.municipio,
        colonia:this.preventa.colonia,
        calle:this.preventa.calle,
        cp:this.preventa.cp,
        medio:this.preventa.medio,
        id:this.preventa.id,
        estatus:this.preventa.estatus
      };
      console.log("valida_cliente");
      console.log(postData);
      this.authService.service("/api/upd_cliente_preventa",postData)
      .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
         
            
          swal.fire('¡ok! ', '', 'success');
            this.uploadFileToActivity();            
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta! ', '', 'error');
        });   

    }
  }
  can_edcli(){
    this.bdn_edit=0;
    this.secc_(1);
  }
  nvo_resp(){
    this.secc_(3);
    this.bndbtn_ed=false;
    this.responsable={
      id:0,
      nombre:"",
      proveedor:"",
      paterno:"",
      materno:"",
      cargo:"",
      rs:"",
      rfc:"",
      correo:"",
      tel1:"",
      ext1:"",
      direccion:""      
    };
  }
  valida_resp(){
    return true;
  }
  edita_resp(itm){
      this.secc_(3);
      this.responsable={
        id:itm.id,
        proveedor:itm.proveedor,
        nombre:itm.nombre,
        paterno:itm.paterno,
        materno:itm.materno,
        cargo:itm.cargo,
        rs:itm.razonsocial,
        rfc:itm.rfc,
        correo:itm.correo,
        tel1:itm.telefono,
        ext1:itm.ext,
        direccion:itm.direccion        
      };
  }
  eli_resp(itm){
    let postData={
      id:itm.id
    };
    console.log(postData);
    this.authService.service("/api/eli_resp",postData)
    .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        this.get_responsable(this.preventa.id);
        this.secc_(1)
        this.router.navigate(["cliente"]);
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('¡API incorrecta! ', '', 'error');
      });
    
  }
  responsable={
    id:0,
    nombre:"",
    proveedor:"",
    paterno:"",
    materno:"",
    cargo:"",
    rs:"",
    rfc:"",
    correo:"",
    tel1:"",
    ext1:"",
    direccion:""    
  };
  fn_gda_resp(){
    let postData={
      responsable:this.responsable,
      id_cliente:this.preventa.id
    };
    console.log(postData);
    this.authService.service("/api/gda_resp",postData)
    .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        this.get_responsable(this.preventa.id);
        this.secc_(2)
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('¡API incorrecta! ', '', 'error');
      }); 
  }
  fn_upd_resp(){    
    let postData={
      responsable:this.responsable
    };
    console.log(postData);
    this.authService.service("/api/upd_resp",postData)
    .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        this.get_responsable(this.preventa.id);
        this.secc=1;
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('¡API incorrecta! ', '', 'error');
      }); 

  }
  fn_gda_cliente(){
    if(this.valida_cliente()==true){
      let postData={
        id_cliente:0,
        nombre:this.preventa.nombre,
        paterno:this.preventa.paterno,
        materno:this.preventa.materno,
        razonsocial:this.preventa.rs,
        rfc:this.preventa.rfc,
        correo:this.preventa.correo,
        telefono:this.preventa.tel1,
        telefono2:this.preventa.tel2,
        cargo:this.preventa.cargo,
        ext1:this.preventa.ext1,
        ext2:this.preventa.ext2,
        pais:this.preventa.pais,
        estado:this.preventa.estado,
        sufijo:this.preventa.sufijo,
        municipio:this.preventa.municipio,
        colonia:this.preventa.colonia,
        calle:this.preventa.calle,
        cp:this.preventa.cp,
        medio:this.preventa.medio
      };
      console.log(postData)
      this.authService.service("/api/gda_cliente_id_cliente",postData)
      .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          if (res.length!=0)
          {
            this.secc_(2);
            this.ls_cliente_preventa();
           
            let postDatapms={
              id_usuario:localStorage.getItem("usuario"),
              id_cliente:res.insertId
            }
            console.log
            this.authService.service("/api/gda_pms",postDatapms)
            .then(
              data => {
              },
              error => {
                  var de= JSON.stringify(error);
                  var di = JSON.parse(de)
                  swal.fire('¡API incorrecta! PMS ', '', 'error');
              });   
              this.uploadFileToActivity();
          }           
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta! ', '', 'error');
        });   

    }
  }
  ls_cliente_preventa(){
    this.loading=true;
    this.preventas=[];
    let postData={ 
      id_usuario:localStorage.getItem("usuario")
    };
    var sc="";
    console.log(postData);
    if(this.facturas==1){

      sc="/api/get_cliente"
    }else{
      sc="/api/get_cliente_id"
    }
    this.authService.service(sc,postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          if (res.length!=0)
          {
            this.preventas=data;
          }          
          this.loading=false; 
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta! ', '', 'error');
        });   
  }

  seguimiento(itm){
    console.log(itm);
    localStorage.setItem("id_cliente",itm.id); 
    localStorage.setItem("nom_cliente",itm.razonsocial); 
    localStorage.setItem("cliente",itm.id);
    localStorage.setItem("cliente_",JSON.stringify(itm));
    if(Number(localStorage.getItem("facturas"))==0){
      this.router.navigate(['/raciv2']);
    }else{
      this.router.navigate(['/rolec']);
    }
  }
  bndNvoREsp;
  bndbtn_ed;
  secc=2;
  bdn_edit;
  secc_(c){
    this.secc=c;
    switch (c) {
      case 1:
        this.bdn_edit=0;
        this.limpia_form();        
        break;
      default:
        break;
    }
  }
  
  preventa={
    sufijo:"",
    estatus:"",
    id:0,
    nombre:"",
    paterno:"",
    materno:"",
    cargo:"",
    rs:"",
    rfc:"",
    correo:"",
    tel1:"",
    tel2:"",
    ext1:"",
    ext2:"",
    pais:"",
    estado:"",
    municipio:"",
    colonia:"",
    calle:"",
    cp:"",
    medio:""
  }
  limpia_form(){
    this.preventa.id=0;
    this.preventa.nombre="";
    this.preventa.sufijo="";
    this.preventa.paterno="";
    this.preventa.materno="";
    this.preventa.cargo=""
    this.preventa.rs="";
    this.preventa.rfc="";
    this.preventa.correo="";
    this.preventa.tel1="";
    this.preventa.tel2="";
    this.preventa.ext1="";
    this.preventa.ext2="";
    this.preventa.pais="";
    this.preventa.estado="";
    this.preventa.municipio="";
    this.preventa.colonia="";
    this.preventa.calle="";
    this.preventa.cp="";
    this.preventa.medio="";
    this.preventa.estatus=""
  }
  responsables=[];
  get_responsable(id){
    let postData={
      id:id,
    };
    console.log(postData);
    this.authService.service("/api/get_responsable_cliente",postData)
    .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        this.responsables=res;
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('¡API incorrecta! get_responsable_cliente ', '', 'error');
      });   
  }
  elim_cli(){
    if(confirm("Confirm to delete this record?")==false)return;
    let postData={
      id:this.id_cliente,
    };
    console.log(postData);
    this.authService.service("/api/elim_cli",postData)
    .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        //this.ls_cliente_preventa();
        this.router.navigate(["/cliente"])
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('¡API incorrecta! ', '', 'error');
      }); 
  }
  edita_preventa(itm){
    this.bndNvoREsp=true;
    this.bndbtn_ed=true;
    this.secc_(1);
    this.get_responsable(itm.id);
    this.bdn_edit=1;
    this.preventa.id=itm.id;
    this.preventa.nombre=itm.nombre;
    this.preventa.paterno=itm.paterno;
    this.preventa.materno=itm.materno;
    this.preventa.rs=itm.razonsocial;
    this.preventa.sufijo=itm.sufijo;
    this.preventa.rfc=itm.rfc;
    this.preventa.cargo=itm.cargo,
    this.preventa.correo=itm.correo;
    this.preventa.tel1=itm.telefono;
    this.preventa.tel2=itm.telefono2;
    this.preventa.ext1=itm.ext1;
    this.preventa.ext2=itm.ext2;
    this.preventa.pais=itm.pais;
    this.preventa.estado=itm.estado;
    this.preventa.municipio=itm.municipio;
    this.preventa.colonia=itm.colonia;
    this.preventa.calle=itm.calle;
    this.preventa.cp=itm.cp;
    this.preventa.medio=itm.medio;
    this.preventa.estatus=itm.estatus

  }
}
